import React from "react";
import ModalWrapper from './ModalWrapper';

const Diversidade = props => {
  return(
    <ModalWrapper
      {...props}
    >
      <div>
        <h4>Diversidade</h4>
        <p>Acreditamos e somos comprometidos com a diversidade social e cultural. Para isso, temos iniciativas que combatem todas as formas de discriminação e preconceitos. Trabalhamos com os 5 temas prioritários:</p>
        <ul className="list-unstyled">
          <li>
            Equidade de gênero;
          </li>
          <li>
            Equidade racial;
          </li>
          <li>
            Diversidade etária;
          </li>
          <li>
            Inclusão e desenvolvimento de pessoas com deficiência;
          </li>
          <li>
            Respeito aos direitos LGBTI+.
          </li>
          <li>
            Mais detalhes em nosso Relatório Anual.
          </li>
        </ul>
      </div>
    </ModalWrapper>
  );
};

export default Diversidade;



// WEBPACK FOOTER //
// ./src/components/Diversidade.js